import { Directive } from '@angular/core';

@Directive({
  selector: '[xpoTag]',
  host: { class: 'xpo-tag' },
})
export class XpoTag {}
